<script setup lang="ts">
/**
 * Quiz welcome: AIRA as a companion (Hero with Glow + AI stars), title,
 * Meta row of glass pills, one Continue. No dismiss button — × in the header exits.
 */
import { FairButton } from '@/ui/primitives/FairButton'
import FairQuizGlassPill from './FairQuizGlassPill.vue'
import FairQuizHero from './FairQuizHero.vue'

interface FairQuizWelcomePill {
  label: string
  star?: boolean
}

interface FairQuizWelcomeProps {
  title: string
  subtitle?: string
  pills?: FairQuizWelcomePill[]
  continueLabel?: string
  continueLoading?: boolean
  /** Hero stars are lavender (AI); flows without an AI mark (Measurements) hide them. */
  aiMark?: boolean
}

withDefaults(defineProps<FairQuizWelcomeProps>(), {
  subtitle: '',
  pills: () => [],
  continueLabel: 'Continue',
  continueLoading: false,
  aiMark: true,
})

const emit = defineEmits<{
  continue: []
}>()
</script>

<template>
  <div class="fair-quiz-welcome">
    <FairQuizHero :ai-mark="aiMark" />

    <div class="fair-quiz-welcome__head">
      <h2 class="fair-quiz-welcome__title">
        {{ title }}
      </h2>
      <p
        v-if="subtitle"
        class="fair-quiz-welcome__subtitle"
      >
        {{ subtitle }}
      </p>
    </div>

    <div
      v-if="pills.length"
      class="fair-quiz-welcome__meta"
    >
      <FairQuizGlassPill
        v-for="pill in pills"
        :key="pill.label"
        :label="pill.label"
        :star="pill.star ?? true"
      />
    </div>

    <div class="fair-quiz-welcome__footer">
      <FairButton
        class="fair-quiz-welcome__continue"
        variant="primary"
        size="auto"
        :label="continueLabel"
        :loading="continueLoading"
        @click="emit('continue')"
      />
    </div>
  </div>
</template>
